import _regeneratorRuntime from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  props: {
    level: {
      type: Number,
      default: 2
    }
  },
  data: function data() {
    return {
      visible: false,
      addressList: []
    };
  },
  computed: {
    options: function options() {
      var _this$$store$state$ad;
      return this.recursionArr(((_this$$store$state$ad = this.$store.state.addressLibrary[0]) === null || _this$$store$state$ad === void 0 ? void 0 : _this$$store$state$ad.children) || [], 1);
    },
    region: function region() {
      this.visible = false;
      this.$emit('change', this.$store.state.region);
      return this.$store.state.region || [];
    },
    regionName: function regionName() {
      var _this = this;
      var nameArr = [];
      var regionArr = this.options;
      if (this.region.length) {
        this.region.forEach(function (item, index) {
          var regionObj = regionArr.find(function (item2) {
            return item2.value === item;
          });
          regionArr = (regionObj === null || regionObj === void 0 ? void 0 : regionObj.children) || [];
          if (index + 1 <= _this.level) {
            nameArr.push((regionObj === null || regionObj === void 0 ? void 0 : regionObj.label) || '');
          }
        });
      }
      return nameArr.join(' / ');
    },
    isLogin: function isLogin() {
      return this.$store.state.isLogin;
    }
  },
  watch: {
    isLogin: {
      handler: function handler(val) {
        if (val) {
          this.getAddressList();
        }
      }
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.getAddressOptions();
            _this2.getAddressList();
            if (_this2.$store.state.region.length == 0) {
              _this2.getDefaultCity();
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {},
  methods: {
    getAddressOptions: function getAddressOptions() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this3.options.length == 0)) {
                _context2.next = 4;
                break;
              }
              _context2.next = 3;
              return _this3.$store.dispatch('getAddressOptions');
            case 3:
              _this3.$forceUpdate();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getAddressList: function getAddressList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var ret;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this4.apiGet("/bbb/pc/userCenter/stockAddress/pageList/10", {
                pageNum: 1,
                pageSize: 10
              });
            case 3:
              ret = _context3.sent;
              if (ret.code == 200) {
                _this4.addressList = ret.data.content || [];
              }
              _context3.next = 9;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 7]]);
      }))();
    },
    getDefaultCity: function getDefaultCity() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var ret, arr;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _this5.apiGet("/bbb/pc/region/toDefaultCityByIp");
            case 3:
              ret = _context4.sent;
              if (ret.code == 200) {
                arr = [ret.data.provinceCode, ret.data.cityCode];
                _this5.$store.commit('set_region', arr);
                _this5.$emit('change', arr);
              }
              _context4.next = 9;
              break;
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 7]]);
      }))();
    },
    recursionArr: function recursionArr(arr, level) {
      var _this6 = this;
      return arr.map(function (item) {
        return {
          value: item.regionCode,
          label: item.regionName,
          children: _this6.level === level ? null : _this6.recursionArr(item.children, level + 1)
        };
      });
    },
    handleClickChange: function handleClickChange(val) {
      if (val.every(function (item) {
        return !!item;
      })) {
        this.$store.commit('set_region', val);
        this.$emit('change', val);
      }
    }
  }
};